import { render, staticRenderFns } from "./RefundRecordList.vue?vue&type=template&id=f063ddfc&scoped=true"
import script from "./RefundRecordList.vue?vue&type=script&lang=js"
export * from "./RefundRecordList.vue?vue&type=script&lang=js"
import style0 from "./RefundRecordList.vue?vue&type=style&index=0&id=f063ddfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f063ddfc",
  null
  
)

export default component.exports